import { Plan } from 'context/AuthContext'

/**
 * Código devolvido pela API (concern PlanGated) quando o merchant não pode criar
 * o recurso por causa do plano.
 */
export const PLAN_UPGRADE_REQUIRED_CODE = 'plan_upgrade_required'

/**
 * Evento de janela emitido pelo DataService ao receber esse código. O Layout
 * escuta e abre o modal de upgrade — necessário porque o DataService não é um
 * componente React e não acessa o AuthContext diretamente.
 */
export const PLAN_UPGRADE_REQUIRED_EVENT = 'clientbase:plan-upgrade-required'

export type PlanUpgradeRequiredDetail = {
  resourceName?: string
  plan?: Plan
}

/**
 * Evento emitido quando o perfil do merchant chega com um valor de
 * `creation_blocked` diferente do que está no token. Mantém o bloqueio em dia
 * sem esperar o próximo login — importante para quem acabou de assinar.
 */
export const CREATION_BLOCKED_SYNC_EVENT = 'clientbase:creation-blocked-sync'

export type CreationBlockedSyncDetail = {
  creationBlocked: boolean
}

/**
 * Evento emitido quando o perfil do merchant chega com as capabilities do
 * plano atual. O claim `capabilities` do JWT só é reemitido no login e o token
 * dura 7 dias, então quem trocava de plano seguia sem o recurso liberado na
 * interface até entrar de novo (SC-10878). Mesma ideia do evento acima.
 */
export const CAPABILITIES_SYNC_EVENT = 'clientbase:capabilities-sync'

export type CapabilitiesSyncDetail = {
  capabilities: Record<string, unknown>
}

/**
 * Modais da campanha de fim do plano Free:
 * - `small`: oferta do Start (free com até 20 cobranças pagas)
 * - `generic`: novos planos (free com mais de 20 cobranças)
 * - `trial_ended`: novos planos, com a copy de período gratuito encerrado
 */
export type CampaignModalKind = 'small' | 'generic' | 'trial_ended'

/**
 * Emitido quando um merchant com a conta limitada tenta criar algo. O Layout
 * escuta e abre o modal da campanha correspondente ao perfil dele.
 */
export const CAMPAIGN_MODAL_EVENT = 'clientbase:campaign-modal'

export type CampaignModalDetail = {
  kind: CampaignModalKind
}
